import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Map as LeafletMap, TileLayer, Polygon, Polyline, Marker, Tooltip } from 'react-leaflet'
import { divIcon } from 'leaflet'
import L from 'leaflet'
import { cloneDeep } from 'lodash'
import moment from 'moment'

import { MAP_URL, startDateFormatString } from './../../js/constants'
import { latLongFromBearingAndDistance } from './../../utils/geoUtils'
import { getBounds } from '../../utils/geoUtils'
import { getAllBerthsAtQuays } from '../../utils/general'
import 'leaflet/dist/leaflet.css'
import './Map.scss'

export default class Map extends PureComponent {
  static propTypes = {
    config: PropTypes.object.isRequired,
    loadingShipsDetails: PropTypes.bool.isRequired,
    selectedShip: PropTypes.object
  }

  render() {
    const bounds = this.calculateSelectedShipMapBounds(this.props.selectedShip, this.props.config.center)

    const canRenderShip = this.props.selectedShip && this.props.selectedShip.location

    return (
      <div className="map-container">
        <LeafletMap ref={el => (this.leafletMap = el)} bounds={bounds}>
          <TileLayer url={MAP_URL} tileSize={512} zoomOffset={-1} />
          {this.renderTerminalOnMap(this.props.config)}
          {this.renderBerthsOnMap(this.props.config)}
          {canRenderShip ? this.renderSelectedShipOnMap(this.props.selectedShip) : null}
        </LeafletMap>
      </div>
    )
  }

  calculateSelectedShipMapBounds = (selectedShip, terminalCenter) => {
    const shipLocation =
      selectedShip && selectedShip.location ? cloneDeep(selectedShip.location.coordinates).reverse() : null
    // Initialize the mapbounds
    return selectedShip && shipLocation ? getBounds([terminalCenter, shipLocation]) : this.getDefaultInitialMapBounds()
  }

  getDefaultInitialMapBounds = () => {
    // Set the initial mapbounds (bounding box around terminal)
    // todo: calculate boundingbox around mapCenter dynamically
    const southWest = L.latLng(51.287608, 3.869768),
      northEast = L.latLng(51.264205, 3.812875),
      initialMapBounds = L.latLngBounds(southWest, northEast)
    return initialMapBounds
  }

  /**
   * Render the terminal on the map
   * @param terminal
   */
  renderTerminalOnMap = terminal => {
    const emptyIcon = divIcon({
      html: '<div/>',
      iconAnchor: [0, 0]
    })

    return (
      <Marker position={terminal.center} opacity={0} icon={emptyIcon}>
        <Tooltip permanent={true}>
          <span>{terminal.name}</span>
        </Tooltip>
      </Marker>
    )
  }

  /**
   * Render the berths on the map
   * @param config
   */
  renderBerthsOnMap = config => {
    return getAllBerthsAtQuays(config.quays).map(berth => {
      // @ts-ignore
      if (berth?.berth?.area?.coordinates?.[0]) {
        return (
          // @ts-ignore
          <Polygon key={berth.berthId} positions={berth.berth.area.coordinates[0].map(c => [c[1], c[0]])} opacity={1}>
            <Tooltip>
              <span>{berth.terminalName}</span>
            </Tooltip>
          </Polygon>
        )
      } else {
        return null
      }
    })
  }

  fixNanShipTransponderPosition = (transponderPosition, location) => {
    if (isNaN(transponderPosition[0]) || isNaN(transponderPosition[1])) {
      return location.coordinates
    }
    return transponderPosition
  }
  /**
   * Render the selected ship on the map
   * @param ship
   * @returns {*}
   */
  renderSelectedShipOnMap = ship => {
    if (!ship || !ship.positionOfTransponder) {
      return null
    }

    const trueHeading = ship.trueHeading !== 511 ? ship.trueHeading : ship.courseOverGround
    const transponderPositionBow = latLongFromBearingAndDistance(
      ship.location,
      ship.positionOfTransponder.distanceToBow,
      trueHeading
    )
    const transponderPositionStern = latLongFromBearingAndDistance(
      ship.location,
      -ship.positionOfTransponder.distanceToStern,
      trueHeading
    )

    const latLongBow = this.fixNanShipTransponderPosition(transponderPositionBow, ship.location)
    const latLongStern = this.fixNanShipTransponderPosition(transponderPositionStern, ship.location)

    const lineString = [latLongBow, latLongStern]

    const shipColor =
      ship.timeLastUpdate < moment().subtract(1, 'days').valueOf()
        ? '#c0c0c0' //$color-grey
        : '#2f61ff'

    const updatedTime = moment(ship.timeLastUpdate).format(startDateFormatString)

    return (
      <Polyline key={ship.mmsi} positions={lineString} color={shipColor} opacity={1} weight={15}>
        <Tooltip permanent={true}>
          <>
            <span>
              {ship.name}
              <br />
              Updated: {updatedTime}
            </span>
          </>
        </Tooltip>
      </Polyline>
    )
  }
}
